import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    gtag: (command: string, action: string, params?: Record<string, any>) => void;
    dataLayer: any[];
  }
}

export const GoogleAnalytics = () => {
  const location = useLocation();
  const isProd = process.env.REACT_APP_NODE_ENV === 'production';

  useEffect(() => {
    if (isProd && typeof window.gtag !== 'undefined') {
      window.gtag('config', 'G-243Q5BNMMT', {
        page_path: location.pathname + location.search,
      });
    }
  }, [location, isProd]);

  return null;
};

export const trackUserSignUp = (userId: string) => {
  window.dataLayer = window.dataLayer || [];

  if (typeof window.dataLayer !== 'undefined') {
    window.dataLayer.push({ event: 'sign-up', userId });
    console.log('Sign up event sent for userId:', userId);
  }
};

export const trackJoinTable = (userId: string, tableId: string, amount: number) => {
  window.dataLayer = window.dataLayer || [];
  console.log('tjt', userId, tableId, amount);
  // Initialize dataLayer if it doesn't exist
  if (typeof window.dataLayer !== 'undefined') {
    // Push join table event for internal tracking
    window.dataLayer.push({
      event: 'join-table',
      userId: userId,
      tableId: tableId,
      amount: amount,
    });
    console.log('Join table event sent for userId:', userId);
  }
};
